// extracted by mini-css-extract-plugin
module.exports = {"unauthorized":"unauthorized_unauthorized__1cZix","unauthorized-msg":"unauthorized_unauthorized-msg__q8Dr1"};